import React from 'react'
import classnames from 'classnames'

const Checkmark = ({className, ...props}) => (
  <svg className={classnames('Icon', className)} viewBox="0 0 32 32" {...props}>
    <path d="M16 26c5.523 0 10-4.477 10-10S21.523 6 16 6 6 10.477 6 16s4.477 10 10 10zm0 2C9.373 28 4 22.627 4 16S9.373 4 16 4s12 5.373 12 12-5.373 12-12 12zm5.695-14.214l-5.75 5.857c-.52.493-1.311.515-1.797 0l-2.874-3.294c-.388-.442-.342-1.13 0-1.464.34-.335.941-.415 1.437 0l2.515 2.196 5.031-4.759c.512-.488 1.193-.272 1.492.048.299.32.433.898-.054 1.416z" />
  </svg>
);

export default Checkmark;
